import { all, fork, put, takeEvery, takeLatest, call } from 'redux-saga/effects';
import { getTransactionHistory, getDeletedTransactionHistory } from "./api";
import { TransactionHistoryActionTypes } from "./constannts";

function* getTransactionHistoryFunction(data) {
    try {
        yield put({
            type: TransactionHistoryActionTypes.TRANSACTION_HISTORY_LOADING,
            payload: {},
        });
        const response = yield call(getTransactionHistory, data);
        if (response.data.status) {
            yield put({
                type: TransactionHistoryActionTypes.TRANSACTION_HISTORY_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: TransactionHistoryActionTypes.TRANSACTION_HISTORY_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: TransactionHistoryActionTypes.TRANSACTION_HISTORY_ERROR,
            payload: error,
        });
    }
};

function* getDeletedTransactionHistoryFunction(data) {
    try {
        yield put({
            type: TransactionHistoryActionTypes.DELETED_TRANSACTION_HISTORY_LOADING,
            payload: {},
        });
        const response = yield call(getDeletedTransactionHistory, data);
        if (response.data.status) {
            yield put({
                type: TransactionHistoryActionTypes.DELETED_TRANSACTION_HISTORY_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: TransactionHistoryActionTypes.DELETED_TRANSACTION_HISTORY_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: TransactionHistoryActionTypes.DELETED_TRANSACTION_HISTORY_ERROR,
            payload: error,
        });
    }
};


export function* watchGetHistory() {
    yield takeLatest(TransactionHistoryActionTypes.TRANSACTION_HISTORY_FIRST, getTransactionHistoryFunction);
    yield takeLatest(TransactionHistoryActionTypes.DELETED_TRANSACTION_HISTORY_FIRST, getDeletedTransactionHistoryFunction);
}

function* historySaga() {
    yield all([
        fork(watchGetHistory),
    ]);
}
export default historySaga;